// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M10.6432 8.848C11.2699 8.45633 11.2699 7.54367 10.6432 7.152L5.53 3.95625C4.86395 3.53997 4 4.01881 4 4.80425L4 11.1958C4 11.9812 4.86395 12.46 5.53 12.0438L10.6432 8.848Z" />
    </svg>
  );
};
